import { CatalogCategory } from '@/shared/types/catalog';
import './index.less';
import { isEmpty, map } from 'lodash-es';
import cN from 'classnames';
import { ParamKey } from '@/shared/types/url-params';
import { useQueryParams } from '@/shared/hooks';
import { cloneElement, useEffect, useMemo, useState } from 'react';
import { Dropdown, MenuProps, Space } from 'antd';
import FilterIcon from '@/components/Common/Icons/FilterIcon';
import ArrowButtonRightIcon from '@/components/Common/Icons/ArrowButtonDownIcon';

interface CategoryFilterProps {
  L3Categories: CatalogCategory[];
}

const CategoryFilter = ({ L3Categories }: CategoryFilterProps) => {
  const { queryParams, setQueryParams } = useQueryParams<{}>();
  const l3CategoryId = queryParams.get(ParamKey.L3_CATEGORY_ID) ?? null;
  const [selectedL3Id, setSelectedL3Id] = useState<string | null>();

  const categoryMenus: MenuProps['items'] = useMemo(() => {
    const menus = L3Categories.map((category) => {
      return {
        key: category.id?.toString(),
        label: <p className="category-dropdown-item">{category.subgroup}</p>,
      };
    });

    menus.unshift({
      key: 'all',
      label: <p className="category-dropdown-item">All categories</p>,
    });

    return [
      {
        key: 'category',
        type: 'group',
        label: 'FILTER BY',
        children: menus,
      },
    ];
  }, [L3Categories]);

  useEffect(() => {
    setSelectedL3Id(l3CategoryId ? l3CategoryId : null);
  }, [l3CategoryId]);

  const categoryTabs = (
    <ul className="category-tabs">
      <li
        className={cN('option', { active: selectedL3Id === null })}
        onClick={() => {
          setQueryParams({ [ParamKey.L3_CATEGORY_ID]: null });
          setSelectedL3Id(null);
        }}
      >
        All categories
      </li>
      {map(L3Categories, (category: CatalogCategory) => {
        if (isEmpty(category)) {
          return null;
        }

        return (
          <li
            key={category.id}
            className={cN('option', { active: selectedL3Id === category?.id?.toString() })}
            onClick={() => {
              setQueryParams({ [ParamKey.L3_CATEGORY_ID]: category.id });
              setSelectedL3Id(category.id?.toString());
            }}
          >
            {category.subgroup}
          </li>
        );
      })}
    </ul>
  );

  const categoryDropdown = (
    <Dropdown
      className="category-tabs-dropdown"
      menu={{
        items: categoryMenus,
        onClick: ({ key }) => {
          if (key === 'all') {
            setQueryParams({ [ParamKey.L3_CATEGORY_ID]: null });
            setSelectedL3Id(null);
          } else {
            setQueryParams({ [ParamKey.L3_CATEGORY_ID]: key });
            setSelectedL3Id(key);
          }
        },
      }}
      dropdownRender={(menu) => (
        <div className="category-dropdown-items">{cloneElement(menu as React.ReactElement)}</div>
      )}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <FilterIcon className="filter-icon" fill="#6B6B6B" />
          <span className="selected-category">
            {selectedL3Id
              ? L3Categories.filter((l3) => l3.id?.toString() === selectedL3Id)[0]?.subgroup
              : 'All categories'}
          </span>
          <ArrowButtonRightIcon className="arrow-down-svg" fill="#6B6B6B" />
        </Space>
      </a>
    </Dropdown>
  );

  const renderCategoryTabs = () => {
    if (L3Categories && L3Categories?.length <= 3) {
      return categoryTabs;
    }

    return categoryDropdown;
  };

  return <div className="sourcing-category-filter-box">{renderCategoryTabs()}</div>;
};

export default CategoryFilter;
